import './Header.css';
import Instagram from '../../static/redesSociais/Instagram';
import WhatsApp from '../../static/redesSociais/Whatsapp';
import React, { useState, useEffect } from 'react';

function Header(){
    const [activeSection, setActiveSection] = useState('home');
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToSection = (sectionId) => {
        const section = document.getElementById(`${sectionId}-section`);
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setActiveSection(sectionId);
        }
    };

    return(
        <div className={`navbar-container ${scrolled ? 'navbar-transparent' : 'navbar-black'}`}>
            <div className='image-navbar-container'>
                <div className='image-navbar'>
                    <img
                        src={process.env.PUBLIC_URL + `/images/Logos/${scrolled ? 'logoDU_preto' : 'logoDU_branco'}.png`}
                        alt="Logo DU Navbar"
                        className="logoDU-image-navbar"
                    />
                </div>
                <div className='DUname-container'>
                    <div className='DUname-text'>
                        <p className={scrolled ? 'text-dark' : 'text-white'}>D.U</p>
                    </div>
                </div>
            </div>

            <div className='buttons-navbar-container'>
                <div className='buttons-navbar'>
                    <ul className="navbar-list">
                        {['home', 'clothing', 'about', 'contact'].map((section) => (
                            <li className="navbar-item" key={section}>
                                <button
                                    className={`navbar-link ${scrolled ? 'link-dark' : 'link-white'} ${activeSection === section ? 'active' : ''}`}
                                    onClick={() => scrollToSection(section)}
                                >
                                    {{ home: 'Home', clothing: 'Catálogo', about: 'Sobre', contact: 'Contato' }[section]}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className='redeSocial-navbar-container'>
                <div className={`redeSocial-navbar ${scrolled ? 'icons-dark' : 'icons-white'}`}>
                    <Instagram showText={false} url='https://www.instagram.com/d.u.br/' scrolled={scrolled}/>
                    <WhatsApp scrolled={scrolled}/>
                </div>
            </div>
        </div>
    );
}

export default Header;